export interface MediaAnalysis {
  id: number
  site_id: number
  analysis_type: string
  input_data: string
  result_data: string
  summary: string
  created_at: string
}

export interface MediaDiagnosis {
  id: number
  site_id: number
  page_id: string
  seo_score: number
  breakdown: string
  diagnosis_data: string
  created_at: string
}

// 分析対象（media_analysis）の分析種別。DB保存値は backend/models.py の MediaAnalysisType と対応する。
export const MediaAnalysisType = {
  CONTENT_GAP: 'content_gap', // コンテンツギャップ分析
  KEYWORD_ANALYSIS: 'keyword_analysis', // キーワード分析
  COMPETITOR: 'competitor', // 競合分析（AI推定の自社×競合SWOT・KW順位・業界トレンド）
  COMPETITOR_SERP: 'competitor_serp', // SERP実データ分析
  CITATION: 'citation', // サイテーション分析（GEO/LLMO）
  SHARE_OF_VOICE: 'share_of_voice', // シェア・オブ・ボイス分析（GEO/LLMO）
  SENTIMENT: 'sentiment', // センチメント分析（GEO/LLMO）
  QUERY_FANOUT: 'query_fanout', // クエリファンアウト分析（GEO/LLMO）
  CANNIBALIZATION: 'cannibalization', // カニバリ分析（拡張）
  LINK_STRUCTURE: 'link_structure', // 内部リンク分析（拡張）
  TIMELINE_CANNIBALIZATION: 'timeline_cannibalization', // カニバリ分析の時系列分析
  TIMELINE_LINK_STRUCTURE: 'timeline_link_structure' // 内部リンク分析の時系列分析
} as const

export type MediaAnalysisType = (typeof MediaAnalysisType)[keyof typeof MediaAnalysisType]

// 分析（media_analysis）の実行状態。DB保存値は backend/models.py の MediaAnalysisStatus と対応する。
// analyzing はバックグラウンド実行中で、詳細画面ではAiLoadingを表示してポーリングする。
export type MediaAnalysisStatus = 'analyzing' | 'completed' | 'failed'

// 分析中の進捗（media_analysis.progress のJSON）
export interface MediaAnalysisProgress {
  step?: number
  total_steps?: number
  percent?: number
  message?: string
  detail?: string
}

export const LLMO_ANALYTICS_TYPES = [
  MediaAnalysisType.CITATION,
  MediaAnalysisType.SHARE_OF_VOICE,
  MediaAnalysisType.SENTIMENT,
  MediaAnalysisType.QUERY_FANOUT
] as MediaAnalysisType[]

export const isLLMOAnalysisType = (type: MediaAnalysisType): boolean => {
  return LLMO_ANALYTICS_TYPES.includes(type)
}
